import { defineStore } from 'pinia';
import type { FlightSchoolCourseStudent } from '@/types/FlightSchoolStudent';

export const useSearchResultsStore = defineStore({
    id: 'studentSearchResults',
    state: () => ({
        students: [] as FlightSchoolCourseStudent[],
    }),
    actions: {
        setStudents(students: FlightSchoolCourseStudent[]) {
            this.students = students;
        },
    },
});
